<template>
  <div>
    <v-form v-model="valid">
      <v-text-field v-model="value.code" label="Code"></v-text-field>
      <v-text-field
        v-model="value.userName"
        label="UserName"
        :rules="$isRequiredRule"
      ></v-text-field>
    </v-form>
  </div>
</template>

<script>
import formValidationMixin from "../../../mixins/formValidationMixin";
export default {
  props: {
    value: {
      default() {
        return {
          code: "",
          userName: "",
          environmentIds: [],
        };
      },
    },
  },
  mixins: [formValidationMixin],
  data() {
    return {
      valid: true,
    };
  },
  watch: {},
  methods: {},
  async mounted() {},
};
</script>